import React, { PureComponent } from "react"
import { Collapse } from "@tencent/spaui"
import messageNotifyService from "./services/notify"

// 实例化 Collapse 精简版
class SPAUICollapseMini extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      open: false,
    }

    this.onOpen = this.onOpen.bind(this)
  }

  onOpen(e) {
    this.setState({
      open: !this.state.open,
    })
    if (this.props.currentStatus != 2) {
      messageNotifyService.handleOpen(this.props.msgId, this.props.currentStatus)
    }
  }

  render() {
    const { cssClassName, children, tagName, componentClass } = this.props
    const { open } = this.state
    const CustomTag = `${tagName}`
    const childrenWithProps = React.Children.map(children[0], (child) =>
      React.cloneElement(child, {
        onClick: this.onOpen,
      })
    )
    const content = this.props.children[1]
    return (
      <CustomTag className={cssClassName}>
        {childrenWithProps}
        <Collapse open={open} className={content.props.className} {...this.props}>
          {content}
        </Collapse>
      </CustomTag>
    )
  }
}

export default SPAUICollapseMini
